<finder-component-header [data]="headerData"></finder-component-header>
<div class="map-container">
    @if(showList) {
        <div class="list">
            <finder-accordion [data]="accordionData" (clickedElement)="updateMap($event)" [openCategory]="openCategory"></finder-accordion>
        </div>
    }
    <div class="map keep-zoom-controls" [ngClass]="{'full-width': !showList}">
        <ng-template #finderMap></ng-template>
        @defer {
            <finder-map
                [defaults]="mapData.location.defaults"
                [markerOptions]="{ keyboard: true}"
                (mapIsReady)="listenForMapReady($event)"
            ></finder-map>
        }
    </div>
</div>
